import { useInstantWinsStore } from '@/stores/instant-wins'
import type { RouteLocation } from 'vue-router'

/**
 * Fetch instant wins in the background on all route navigations.
 * This guard doesn't block navigation - it starts the fetch and lets
 * components show skeleton loaders while data is being fetched.
 *
 * The store has built-in caching, so subsequent calls return immediately.
 */
export const fetchInstantWins = async (_to: RouteLocation) => {
  const instantWinsStore = useInstantWinsStore()

  // Keep this fire-and-forget. Do not await the store action here: this guard
  // is called during navigation only to warm the instant-win cache, and must
  // return immediately even if a future caller awaits the guard itself.
  // Promise.resolve() is intentional so testing stubs that return undefined
  // still support .catch().
  Promise.resolve(instantWinsStore.fetchInstantWins()).catch((error) => {
    console.error('Failed to fetch instant wins:', error)
  })
}
